import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";
import "moment-timezone";
import {ProgrammingModel} from "site-apps/distribution/programming/ProgrammingModel";
import DateTimesUtils from "core/utils/DateTimesUtils";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableProgramming = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Td} = useTranslation("datestimes");
    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(parseInt(e.currentTarget.dataset.idx));
        } else {
            items.current.removeFromChosen(parseInt(e.currentTarget.dataset.idx));
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.id);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length !== 1;
        buttons.delete.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const translateValues = (item) => {
        let title = "";
        switch (item.repeat) {
            case "w":
                let day;
                let days = [];
                for (day of item.values.days) {
                    days.push(_Td("days." + day));
                }
                title += days.join(", ");
                break;
            case "m":
                switch (item.values.type) {
                    case "d":
                        title = "Dia " + item.values.day + " de cada mes";
                        break;
                    case "n":
                        title =
                            _Td("the_place." + item.values.value) + " " + _Td("days_name." + item.values.day) + " de cada mes";
                        break;
                    case "p":
                        title =
                            _Td("the_place." + item.values.value) + " " + _Td("days_name." + item.values.day) + " de cada mes";
                        break;
                    default:
                }
                break;
            case "y":
                switch (item.values.type) {
                    case "d":
                        title = "Dia " + item.values.day + " de " + _Td("months_name." + item.values.value);
                        break;
                    case "n":
                        title =
                            _Td("the_place." + item.values.place) +
                            " " +
                            _Td("days_name." + item.values.day) +
                            " de " +
                            _Td("months_name." + item.values.value);
                        break;
                    case "p":
                        title =
                            _Td("the_place." + item.values.place) +
                            " " +
                            _Td("days_name." + item.values.day) +
                            " de " +
                            _Td("months_name." + item.values.value);
                        break;
                    default:
                }
                break;
            default:
                break;
        }
        return title;
    };

    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };

    return (
        <table className="table table-striped table-sticky-horizontal">
            <thead>
                <tr>
                    <th style={{...stickyHeaderStyle}} key="-1">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} styleHeaders={stickyHeaderStyle} />
                </tr>
            </thead>
            <tbody>
                {itemsShow.map((item) => (
                    <tr key={item.id} data-idx={item.id} onClick={onClick}>
                        <td>
                            <input
                                type="checkbox"
                                name="checkboxContainer"
                                key={item.id}
                                data-idx={item.id}
                                defaultChecked={items.current.chosen.includes(item.id)}
                                readOnly={true}
                            />
                        </td>
                        <td>{item.name}</td>
                        <td>{item.description}</td>
                        <td>{_Tc("programming." + item.type)}</td>
                        <td>{item.date_start ? <DateDisplay date={item.date_start} format="DD-MM-YYYY" title={true} /> : "-"}</td>
                        <td>{item.date_end ? <DateDisplay date={item.date_end} format="DD-MM-YYYY" title={true} /> : "-"}</td>
                        <td>{DateTimesUtils.timeToHourMinute(item.compile)}</td>
                        <td>{DateTimesUtils.timeToHourMinute(item.run)}</td>
                        <td>{_Tc("repeat." + item.repeat)}</td>
                        <td>{translateValues(item)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableProgramming;
